export const ENTRY = "/";
export const SIGNIN = "/signin";
export const CONFIRM_EMAIL = "/confirm-email";
export const EMAIL_VERIFICATION = "/email-verification";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "/reset-password";
export const PROTECTED = "/host-manager";

// CLIENTS
export const CLIENT_MANAGE = "/host-manager/client";
export const CLIENT_MANAGE_DETAILS = "/host-manager/client/:id";
export const CLIENT_CREATE = "/host-manager/client/create";
export const CLIENT_BILLING = "/host-manager/client/billing/:clientId";
export const CONFIRM_PAYMENT = "/host-manager/client/confirm-payment";
export const CLIENT_DETAILS = `/host-manager/client`;
export const CLIENT_SUBSCRIPTION_DETAILS = `/host-manager/client/subscription/:id`;
export const CLIENTS_SUBSCRIPTIONS = "/host-manager/client/subscriptions";
export const SUBSCRIPTION_PLANS = "/host-manager/client/subscription/plans";
export const CLIENT_CUSTOM_BILLING = "/host-manager/client/custom-billing/:clientId";
export const ACTIVATE_CUSTOM = "/host-manager/client/activate-custom-plan";
export const CLIENT_CUSTOM_SUBSCRIPTION_DETAILS = `/host-manager/client/custom-subscription/:id`;
export const CLIENT_ONBOARDING_COMPANY = "/host-manager/client/create/:clientId/company";
export const CLIENT_ONBOARDING_PRIMARY_ADMIN = "/host-manager/client/create/:clientId/primary-admin";
export const CLIENT_ONBOARDING_EMPLOYEES = "/host-manager/client/create/:clientId/employees";
export const CLIENT_ONBOARDING_Licenses = "/host-manager/client/create/:clientId/Licenses";
export const CLIENT_ONBOARDING_STARTER_POINTS = "/host-manager/client/create/:clientId/starter-points";
export const CLIENT_ONBOARDING_INVOICE = "/host-manager/client/create/:clientId/invoice";
export const CLIENT_ONBOARDING_PAYMENT = "/host-manager/client/create/:clientId/payment";
export const CLIENT_ONBOARDING_COMPLETE = "/host-manager/client/create/:clientId/live";
export const CLIENT_PROFILE = "/host-manager/client/profile/:id";
export const CLIENT_RENEW_LICENCES = "/host-manager/client/profile/:id/renew";

// SELLERS
export const SELLER = "/host-manager/seller";
export const SELLER_PAYMENT_RESOLUTION = "/host-manager/seller/payment";
export const SELLER_PAYMENT_PRODUCTS = "/host-manager/seller/products";
export const SELLER_PAYMENT_ORDERS = "/host-manager/seller/orders";
export const SELLER_PAYMENT_SELLERS = "/host-manager/seller/sellers";

export const MANAGE_CLIENTS = "/host-manager/manage-clients";
export const MANAGE_CLIENTS_SUBSCRIPTION = "/host-manager/manage-client-subscription";
export const MANAGE_SELLERS_STORES = "/host-manager/manage-sellers-stores";
export const MANAGE_ACCESS_RIGHTS = "/host-manager/access-rights";

export const MANAGE_SELLERS_AND_STORES = "/host-manager/manage-sellers-and-stores";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW = "/host-manager/manage-sellers-and-stores/overview";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT = "/host-manager/manage-sellers-and-stores/overview/products";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_DETAIL = "/host-manager/manage-sellers-and-stores/overview/products/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER = "/host-manager/manage-sellers-and-stores/overview/products/orders";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER_DETAIL = "/host-manager/manage-sellers-and-stores/overview/products/orders/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_BESTSELLER = "/host-manager/manage-sellers-and-stores/overview/products/bestseller";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_BESTSELLER_DETAIL =
  "/host-manager/manage-sellers-and-stores/overview/products/bestseller/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_PAYMENT = "/host-manager/manage-sellers-and-stores/overview/products/payment-resolution";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE = "/host-manager/manage-sellers-and-stores/overview/services";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_DETAIL = "/host-manager/manage-sellers-and-stores/overview/services/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_ORDER = "/host-manager/manage-sellers-and-stores/overview/services/orders";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_BESTSELLER = "/host-manager/manage-sellers-and-stores/overview/services/bestseller";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_PAYMENT = "/host-manager/manage-sellers-and-stores/overview/services/payment-resolution";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR = "/host-manager/manage-sellers-and-stores/overview/vendors";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_BESTSELLER = "/host-manager/manage-sellers-and-stores/overview/vendors/bestseller";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_DETAIL = "/host-manager/manage-sellers-and-stores/overview/vendors/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_PAYMENT = "/host-manager/manage-sellers-and-stores/overview/vendors/payment";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_PAYMENT_DETAIL = "/host-manager/manage-sellers-and-stores/overview/vendors/payment/:id";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_APPROVAL = "/host-manager/manage-sellers-and-stores/overview/vendors/approval";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PROMOTION = "/host-manager/manage-sellers-and-stores/overview/promotions";
export const MANAGE_SELLERS_AND_STORES_OVERVIEW_PAYMENT_DETAIL = "/host-manager/manage-sellers-and-stores/overview/payment/:id";
export const MANAGE_SELLERS_AND_STORES_TRANSACTION_DETAIL = "/host-manager/manage-sellers-and-stores/overview/transaction/:id";
export const MANAGE_SELLERS_AND_STORES_TAXONOMY = "/host-manager/manage-sellers-and-stores/taxonomy";

//manage users and buyers
export const MANAGE_USERS_AND_BUYERS = "/host-manager/manage-users-and-buyers";
export const MANAGE_USERS_AND_BUYERS_OVERVIEW = "/host-manager/manage-users-and-buyers/overview";
export const MANAGE_USERS_AND_BUYERS_COMPANY = "/host-manager/manage-users-and-buyers/company";
export const MANAGE_USERS_AND_BUYERS_COMPANY_TOP_CUSTOMER = "/host-manager/manage-users-and-buyers/company/top-customer";
export const MANAGE_USERS_AND_BUYERS_SUBSCRIPTION = "/host-manager/manage-users-and-buyers/subscriptions";

export const PRODUCT = "/host-manager/products";
export const PRODUCT_DETAILS = "/host-manager/products/:id";

export const POINT = "/host-manager/points";
export const POINT_OVERVIEW = "/host-manager/points";
export const POINT_COMPANY_DETAILS = "/host-manager/points/companies/:id";
export const POINT_COMPANY_ALLOCATION_DETAILS = "/host-manager/points/companies/:id/allocations/:Id";
export const POINT_PRICING = "/host-manager/points/pricing";

export const INVOICE = "/host-manager/invoices";
export const INVOICE_DASHBOARD = "/host-manager/invoices";
export const INVOICE_LIST = "/host-manager/invoices/list";

export const DISPUTE = "/host-manager/dispute";
export const DISPUTE_LIST = "/host-manager/dispute";
export const DISPUTE_BUYER_DETAILS = "/host-manager/dispute/buyer/:id";
export const DISPUTE_SELLER_DETAILS = "/host-manager/dispute/seller/:id";
export const ACCESS_RIGHT = "/host-manager/access-rights";
export const ACCESS_RIGHT_COMPANY = "/host-manager/access-rights";
export const ACCESS_RIGHT_COMPANY_DETAILS = "/host-manager/access-rights/companies/:id";
export const ACCESS_RIGHT_COMPANY_EMPLOYEE_DETAILS = "/host-manager/access-rights/companies/:companyId/employees/:id";
export const ACCESS_RIGHT_COMPANY_EMPLOYEE_ADD = "/host-manager/access-rights/companies/:companyId/employees/add";
export const ACCESS_RIGHT_COMPANY_EMPLOYEE_EDIT = "/host-manager/access-rights/companies/:companyId/employees/:id/edit";
export const ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_DETAILS = "/host-manager/access-rights/companies/:companyId/employee-groups/:id";
export const ACCESS_RIGHT_COMPANY_EMPLOYEE_GROUP_ADD = "/host-manager/access-rights/companies/:companyId/employee-groups/add";

export const USER = "/host-manager/user";
export const USER_MANAGEMENT_OVERVIEW = "/host-manager/user/overview";
export const USER_MANAGEMENT_DETAILS = "/host-manager/user/details/:id";
export const USER_MANAGEMENT_ADMIN_GROUP_CREATE = "/host-manager/user/admin-group/create";
export const USER_MANAGEMENT_ADMIN_GROUP_DETAILS = "/host-manager/user/admin-group/details/:id";
export const USER_MANAGEMENT_PERMISSION_DETAILS = "/host-manager/user/permission/details/:id";
export const USER_MANAGEMENT_PROFILE_DETAILS = "/host-manager/user/profile/details";
export const USER_MANAGEMENT_PROFILE_CREATE = "/host-manager/user/profile/create/:email";

export const SUBSCRIPTION_APPROVAL = "/host-manager/subscription-approval";
export const SUBSCRIPTION_APPROVAL_OVERVIEW = "/host-manager/subscription-approval/overview";
export const SUBSCRIPTION_APPROVAL_DETAILS = "/host-manager/subscription-approval/details/:id";

export const KYC_APPROVAL = "/host-manager/kyc-approval";
export const KYC_APPROVAL_OVERVIEW = "/host-manager/kyc-approval/overview";
// export const KYC_APPROVAL_DETAILS = "/host-manager/kyc-approval/details/:id";

export const REPORT = "/host-manager/report";
export const REPORT_DETAIL = "/host-manager/report/:slug";

export const THIRD_PARTY_BUSINESS = "/host-manager/third-party-businesses";
export const THIRD_PARTY_BUSINESS_CATEGORY = "/host-manager/third-party-businesses/:category";
export const THIRD_PARTY_BUSINESS_DETAIL = "/host-manager/third-party-businesses/:category/:businessId";

export const DELIVERY_PRICING = "/host-manager/delivery-pricing";
export const DELIVERY_PRICING_UPLOAD = "/host-manager/delivery-pricing/upload";
export const DELIVERY_PRICING_ADD_LOCATION = "/host-manager/delivery-pricing/add-location";
